import { useMemo } from 'react';

import EmojiResource from '@atlaskit/emoji/emoji-resource';
import type { OptionalEmojiDescriptionWithVariations } from '@atlaskit/emoji/types';

import { createEmojiProviderParameters } from '@confluence/fabric-emoji-support';
import { getEmojiNodeDataProvider } from '@confluence/fabric-providers/entry-points/EmojiProvider.ts';
import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';
import type { EmojiNodeDataProvider } from '@atlaskit/editor-plugins/emoji';

export function useEmojiNodeDataProvider(): EmojiNodeDataProvider | undefined {
	const { userId, cloudId, isLicensed, isLoggedIn } = useSessionData();

	// We need a special emoji parameters that supports SSR load optimization here.
	const emojiResourceParams = useMemo(() => {
		return createEmojiProviderParameters({
			cloudId,
			userId,
			isLicensed,
			isLoggedIn,
		});
	}, [cloudId, userId, isLicensed, isLoggedIn]);

	const emojiNodeDataProvider = getEmojiNodeDataProvider(EmojiResource, {
		...emojiResourceParams,
		allowAnonymousAccess: true,
	});

	if (emojiNodeDataProvider) {
		const ssrProvidersData: {
			emojiNodeDataProvider?: Record<string, OptionalEmojiDescriptionWithVariations>;
		} = window['__SSR_EDITOR_NODE_DATA_PROVIDERS_DATA__'] || {};
		const ssrData = ssrProvidersData['emojiNodeDataProvider'];

		emojiNodeDataProvider.setSSRData(ssrData);
	}

	return emojiNodeDataProvider;
}
